var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[(_vm.loading)?_c('login-loader'):(_vm.ready)?[_c('navbar'),_c('div',{staticClass:"app-middle"},[_c('router-view'),(_vm.journalPinned)?_c('div',{staticClass:"app-right-block"},[_c('JournalShort')],1):_vm._e()],1),(_vm.modal)?_c('modal-window'):_vm._e()]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }